import { B2bHeader } from 'components/Layout/Header/B2bHeader';
import { B2cHeader } from 'components/Layout/Header/B2cHeader';
import { SimpleB2bHeader } from 'components/Layout/Header/SimpleB2bHeader';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { isB2bDomain } from 'helpers/isDomainLocale';

export type HeaderProps = {
    simple?: boolean;
};

export const HEADER_TEST_IDENTIFIER = 'layout-header';

export const Header: FC<HeaderProps> = ({ simple }) => {
    const domainConfig = useDomainConfig();

    if (isB2bDomain(domainConfig)) {
        return simple ? <SimpleB2bHeader /> : <B2bHeader />;
    }

    return <B2cHeader simple={simple} />;
};
